/* MARWAH Luxury Chat Widget - Free, no monthly fee */
(function() {
  const KB = [
    { k: ['price', 'pricing', 'cost', 'how much', 'quote'],
      a: "Every MARWAH piece is made to order and priced individually based on your metal, diamond, and design choices. Share your vision and we'll prepare a detailed quote. Would you like to start one?" },
    { k: ['long', 'take', 'lead time', 'delivery', 'when will', 'shipping'],
      a: "Approximately 20 days from final design approval, with secure insured delivery. For Christmas delivery order by December 5, for Valentine's Day by January 25." },
    { k: ['metal', 'gold', 'platinum', 'silver', '14k', '18k'],
      a: "We craft in 14k yellow gold, 14k white gold, 18k yellow gold, 18k white gold, platinum, and sterling silver. Every piece is made to order in the metal you choose." },
    { k: ['diamond', 'lab', 'real', 'genuine', 'natural', 'mined'],
      a: "Our lab-grown diamonds are chemically, physically, and optically identical to mined diamonds. Real diamonds, created with advanced technology." },
    { k: ['custom', 'design', 'bespoke', 'personalize', 'change'],
      a: "Every piece shown on our site is an inspiration. You choose the metal, the diamonds, and every detail. Nothing is pulled from a shelf. Shall I connect you with a specialist to begin?" },
    { k: ['contact', 'human', 'person', 'call', 'phone', 'email', 'talk'],
      a: "You can reach us at marwahdiamonds@gmail.com or 201-952-2892. Or tap below and I'll have a specialist reach out to you directly." },
    { k: ['return', 'refund', 'exchange', 'warranty'],
      a: "Because every piece is made to order for you, we handle each request personally. A specialist can walk you through our policies. Shall I connect you?" },
    { k: ['hello', 'hi', 'hey', 'good morning', 'good afternoon', 'good evening'],
      a: "Hello, and welcome to MARWAH. How can I help you today? Ask me about pricing, lead times, metals, or custom designs." }
  ];

  function findAnswer(msg) {
    msg = msg.toLowerCase();
    for (const item of KB) {
      for (const kw of item.k) {
        if (msg.includes(kw)) return item.a;
      }
    }
    return null;
  }

  const css = `
    #marwah-chat-bubble { position: fixed; bottom: 24px; right: 24px; width: 60px; height: 60px; border-radius: 50%; background: #C9A96A; color: #fff; border: none; cursor: pointer; z-index: 9999; font-size: 26px; box-shadow: 0 4px 16px rgba(0,0,0,.2); display: flex; align-items: center; justify-content: center; }
    #marwah-chat-bubble:hover { background: #A8845A; }
    #marwah-chat-panel { position: fixed; bottom: 96px; right: 24px; width: 340px; max-width: calc(100vw - 48px); height: 440px; max-height: calc(100vh - 140px); background: #FAF8F5; border: 1px solid #E8DCC8; border-radius: 12px; z-index: 9999; display: none; flex-direction: column; overflow: hidden; box-shadow: 0 8px 32px rgba(0,0,0,.18); font-family: inherit; }
    #marwah-chat-panel.open { display: flex; }
    #marwah-chat-header { background: #1A1A1A; color: #FAF8F5; padding: 14px 16px; font-size: 15px; letter-spacing: .5px; }
    #marwah-chat-header small { display: block; color: #C9A96A; font-size: 11px; margin-top: 2px; letter-spacing: 0; }
    #marwah-chat-msgs { flex: 1; overflow-y: auto; padding: 14px; display: flex; flex-direction: column; gap: 10px; }
    .mmsg { max-width: 82%; padding: 9px 12px; border-radius: 14px; font-size: 13.5px; line-height: 1.45; }
    .mmsg.bot { background: #F3EDE4; color: #1A1A1A; align-self: flex-start; border-bottom-left-radius: 4px; }
    .mmsg.user { background: #C9A96A; color: #fff; align-self: flex-end; border-bottom-right-radius: 4px; }
    #marwah-chat-input-row { display: flex; border-top: 1px solid #E8DCC8; }
    #marwah-chat-input { flex: 1; border: none; padding: 12px 14px; font-size: 13.5px; background: #fff; outline: none; }
    #marwah-chat-send { background: #1A1A1A; color: #C9A96A; border: none; padding: 0 18px; cursor: pointer; font-size: 14px; }
    #marwah-chat-escalate { background: none; border: none; color: #A8845A; font-size: 12px; cursor: pointer; padding: 8px; text-decoration: underline; }
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const bubble = document.createElement('button');
  bubble.id = 'marwah-chat-bubble';
  bubble.innerHTML = '&#128172;';
  bubble.setAttribute('aria-label', 'Chat with us');
  document.body.appendChild(bubble);

  const panel = document.createElement('div');
  panel.id = 'marwah-chat-panel';
  panel.innerHTML = `
    <div id="marwah-chat-header">MARWAH Concierge<small>Typically replies instantly</small></div>
    <div id="marwah-chat-msgs"></div>
    <button id="marwah-chat-escalate">Talk to a specialist instead</button>
    <div id="marwah-chat-input-row">
      <input id="marwah-chat-input" placeholder="Type your question..." autocomplete="off" />
      <button id="marwah-chat-send">Send</button>
    </div>`;
  document.body.appendChild(panel);

  const msgs = panel.querySelector('#marwah-chat-msgs');
  const input = panel.querySelector('#marwah-chat-input');

  function addMsg(text, who) {
    const d = document.createElement('div');
    d.className = 'mmsg ' + who;
    d.textContent = text;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
  }

  bubble.onclick = () => {
    panel.classList.toggle('open');
    if (panel.classList.contains('open') && !msgs.children.length) {
      addMsg("Welcome to MARWAH. I'm here to help with pricing, lead times, metals, or custom designs. What's on your mind?", 'bot');
    }
  };

  function send() {
    const text = input.value.trim();
    if (!text) return;
    addMsg(text, 'user');
    input.value = '';
    setTimeout(() => {
      const ans = findAnswer(text);
      if (ans) {
        addMsg(ans, 'bot');
      } else {
        addMsg("That's a great question for one of our specialists. Tap 'Talk to a specialist' below and we'll reach out personally.", 'bot');
      }
    }, 600);
  }

  panel.querySelector('#marwah-chat-send').onclick = send;
  input.onkeypress = (e) => { if (e.key === 'Enter') send(); };

  panel.querySelector('#marwah-chat-escalate').onclick = () => {
    const name = prompt("Your name:");
    if (!name) return;
    const contact = prompt("Email or phone number where we can reach you:");
    if (!contact) return;
    const question = prompt("Briefly, what would you like help with?");
    const transcript = Array.from(msgs.querySelectorAll('.mmsg')).map(m =>
      (m.classList.contains('user') ? 'Visitor: ' : 'Concierge: ') + m.textContent).join('\n');

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'form_type=contact&contact[name]=' + encodeURIComponent(name) +
            '&contact[email]=' + encodeURIComponent(contact) +
            '&contact[body]=' + encodeURIComponent('[CHAT ESCALATION]\nQuestion: ' + (question || '') + '\n\nTranscript:\n' + transcript)
    }).then(() => {
      addMsg("Thank you, " + name + ". A specialist will reach out to you shortly at " + contact + ".", 'bot');
    }).catch(() => {
      addMsg("Something went wrong. Please email us directly at marwahdiamonds@gmail.com.", 'bot');
    });
  };
})();
